<div class="range-wrap">
    <input type="range" min="0" max="10" value="0" id="range" [(ngModel)]="value" (input)="input()" #range />
    <div class="range-value" #rangeValue></div>
    <div class="range-limits">
        <span class="range-label">Totalmente desacuerdo</span>
        <span class="range-label">Totalmente de acuerdo</span>
    </div>
</div>